import { useEffect } from "react";

export default function usePageMeta({
  title,
  description,
  canonical,
  ogImage,
}) {
  useEffect(() => {
    if (title) document.title = title;

    const ensure = (selector, create) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = create();
        document.head.appendChild(el);
      }
      return el;
    };

    if (description) {
      const m = ensure('meta[name="description"]', () => {
        const x = document.createElement("meta");
        x.setAttribute("name", "description");
        return x;
      });
      m.setAttribute("content", description);
    }

    if (canonical) {
      const l = ensure('link[rel="canonical"]', () => {
        const x = document.createElement("link");
        x.setAttribute("rel", "canonical");
        return x;
      });
      l.setAttribute("href", canonical);
    }

    if (ogImage) {
      const og = ensure('meta[property="og:image"]', () => {
        const x = document.createElement("meta");
        x.setAttribute("property", "og:image");
        return x;
      });
      og.setAttribute("content", ogImage);
    }
  }, [title, description, canonical, ogImage]);
}
